import { Press } from "../queries/aboutUsQuery";
import PressCard from "./pressCard";
import { RichText } from "./richText";

export function AboutUsPressSection({ press }: { press: Press }) {
  return (
    <>
      <div className="families-colorway">
        <span className="text-overline-2">PRESS</span>
      </div>
      <div className="flex flex-col items-start justify-between lg:flex-row lg:items-baseline">
        <div className="font-rebrand text-heading-38 italic text-onyx md:text-heading-45">
          <strong>{press.title}</strong>
        </div>
        <div className="[&>p>a>span]:text-green">
          {<RichText content={press.subTitle}></RichText>}
        </div>
      </div>

      <div className="grid grid-cols-2 items-center gap-6 pb-8 pt-8 md:grid-cols-4 lg:grid-cols-5">
        {press.companies?.map((company) => (
          <PressCard key={company._id} company={company}></PressCard>
        ))}
      </div>
    </>
  );
}

export default AboutUsPressSection;
